import instagram from "../../assets/websites/instagram.jpg"
import blog from "../../assets/websites/blog.jpg"
import CinemaClub from "../../assets/websites/entertainHub.jpg"
import mobileCommerce from "../../assets/websites/mobile.png"
import BlackGym from "../../assets/websites/black Gym.jpg"
import recipes from "../../assets/websites/recipes.jpg"
import movies from "../../assets/websites/movies.jpg"
import menu from "../../assets/websites/menu.jpg"
import q_and_a from "../../assets/websites/q_and_a.jpg"
// import netflix from "../../assets/websites/netflix.jpg"
// import movies from "../../assets/websites/movies.jpg"

import party from "../../assets/websites/party.png"
import quiz from "../../assets/websites/quiz.jpg"
// import loginForm from "../../assets/websites/loginForm.jpg"
import bookMarker from "../../assets/websites/bookMarker.jpg"
import weather from "../../assets/websites/weather.jpg"
// import portofolio1 from "../../assets/websites/portofolio1.png"
// import portofolio2 from "../../assets/websites/portofolio2.png"
// import portofolio3 from "../../assets/websites/portofolio3.png"
// import portofolio4 from "../../assets/websites/portofolio4.png"
// import portofolio5 from "../../assets/websites/portofolio5.png"
import generatePassword from "../../assets/websites/generatePassword.jpeg"
import languages from "../../assets/websites/languages.jpg"
import Covid from "../../assets/websites/Covid.jpg"
// import coffe from "../../assets/websites/coffe.jpg"
import company from "../../assets/websites/company.png"
// import hospital from "../../assets/websites/hospital.jpg"
import takeaway from "../../assets/websites/takeaway.jpg"
import tourism from "../../assets/websites/world.png"
// import gym from "../../assets/websites/gym.png"
// import dashboard from "../../assets/websites/dashboard.png"



const websitesData = [
    // { img: instagram, title: "instagram", uncompleted:true, },
    { img: CinemaClub, title: "Cinema Club", live: "https://cinemaclub.pages.dev", code: "https://github.com/osama24680/CinemaClub" },
    { img: mobileCommerce, title: "Mobile Market", live: "https://reactphone.pages.dev", code: "https://github.com/osama24680/ReactPhone" },
    { img: blog, title: "Vera", live: "https://vera-green.vercel.app", code: "https://github.com/osama24680/Vera" },
    { img: BlackGym, title: "BlackGym", live: "https://black-gym.vercel.app", code: "https://github.com/osama24680/Black-Gym" },
    { img: recipes, title: "Recipes", live: "https://recipes-5ia.pages.dev", code: "https://github.com/osama24680/Recipes" },
    { img: movies, title: "movies", live: "https://movies-va6.pages.dev", code: "https://github.com/osama24680/movies" },
    { img: menu, title: "menu", live: "https://menu-7qp.pages.dev", code: "https://github.com/osama24680/Menue" },
    { img: q_and_a, title: "Questions and Answers", live: "https://q-and-a.pages.dev", code: "https://github.com/osama24680/Q_and_A" },
    // { img: netflix, title: "Netflix Clone", live: "https://musical-clafoutis-07f905.netlify.app", code: "https://github.com/osama24680/NetflixClone" },
    // { img: movies, title: "Movies clone with Form", live: "https://react-movies-osama.netlify.app", code: "https://github.com/osama24680/ReactMovies" },
    { img: party, title: "Party announcement", live: "https://osama24680.github.io/party/", code: "https://github.com/osama24680/party" },
    { img: quiz, title: "Quiz", live: "https://osama24680.github.io/quiz/", code: "https://github.com/osama24680/quiz" },
    { img: weather, title: "Weather", live: "https://osama24680.github.io/globalWeather/", code: "https://github.com/osama24680/globalWeather" },
    { img: bookMarker, title: "Book Marker", live: "https://osama24680.github.io/bookmarker/", code: "https://github.com/osama24680/bookmarker" },
    { img: generatePassword, title: "Generate Password", live: "https://osama24680.github.io/generatePassword/", code: "https://github.com/osama24680/generatePassword" , class: "hide"},
    { img: languages, title: "languages Learning", live: "https://osama24680.github.io/6-A-app/", code: "https://github.com/osama24680/6-A-app/tree/master", class: "hide" },
    { img: Covid, title: "Covid 19", live: "https://osama24680.github.io/5-corona/", code: "https://github.com/osama24680/5-corona" , class: "hide"},
    // { img: loginForm, title: "Login Form", live: "https://osama24680.github.io/loginForm/", code: "https://github.com/osama24680/loginForm" , class: "hide"},
    // { img: portofolio1, title: "portofolio v1", live: "https://osama24680.github.io/puplic_portofolio1/", code: "https://github.com/osama24680/puplic_portofolio1" },
    // { img: portofolio2, title: "portofolio v2", live: "https://osama24680.github.io/puplic_portofolio2/", code: "https://github.com/osama24680/puplic_portofolio2", class: "hide" },
    // { img: portofolio3, title: "portofolio v3", live: "https://osama24680.github.io/-puplic_portofolio3/", code: "https://github.com/osama24680/-puplic_portofolio3", class: "hide" },
    // { img: portofolio4, title: "portofolio v4", live: "https://osama24680.github.io/portofolio/", code: "https://github.com/osama24680/portofolio", class: "hide" },
    // { img: portofolio5, title: "portofolio v5", live: "https://relaxed-pixie-814043.netlify.app", code: "https://github.com/osama24680/portofolio_V5", class: "hide" },
    // { img: coffe, title: "Coffe Shop", live: "https://osama24680.github.io/7-coffeShop/", code: "https://github.com/osama24680/7-coffeShop/tree/master", class: "hide" },
    { img: company, title: "Company Team", live: "https://osama24680.github.io/comapany/", code: "https://github.com/osama24680/comapany", class: "hide" },
    // { img: hospital, title: "Hospital", live: "https://osama24680.github.io/10-hospital/", code: "https://github.com/osama24680/10-hospital/tree/master", class: "hide" },
    { img: takeaway, title: "takeaway", live: "https://osama24680.github.io/9-restaurant/", code: "https://github.com/osama24680/9-restaurant/tree/master", class: "hide" },
    { img: tourism, title: "tourism ", live: "https://osama24680.github.io/8-tour/", code: "https://github.com/osama24680/8-tour", class: "hide" },
    // { img: gym, title: "Gym", live: "https://osama24680.github.io/gym/", code: "https://github.com/osama24680/gym", class: "hide" },
    // { img: dashboard, title: "Dashboard", live: "https://osama24680.github.io/dashboard/", code: "https://github.com/osama24680/dashboard", class: "hide" },

]

export default websitesData










